'use strict';

/**
 * @module JSON Web Algorithms (JWA)
 */
var JWA = require('./JWA');

/**
 * Export
 */
module.exports = {
  JWA: JWA
};


// WEBPACK FOOTER //
// ./lib/index.js